module.exports = __webpack_public_path__ + "media/images/photos/photo-13-9b84a06159423c67fed8239fffcc41ee.jpg";